import { createFileRoute } from "@tanstack/react-router";
import { BookingProvider } from "@/components/site/booking-context";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileBookingBar } from "@/components/site/MobileBookingBar";
import {
  ReservationFAQ,
  ReservationHero,
  ReservationProcess,
  ReservationSupport,
  AvailabilityRequestForm,
} from "@/components/site/reservations";
import { heroPreloadLink } from "@/data/optimized-images";
import { reservationFaqs, resort } from "@/data/resort";
import { absoluteUrl } from "@/lib/site";
import heroMainAsset from "@/assets/auburn-hero-main.webp.asset.json";


const title = "Check RV Site Availability | Auburn RV Resort";
const description =
  "Request RV site availability at Auburn RV Resort in Auburn, California. Submit your dates, RV information and travel details and our team will contact you regarding availability.";
const ogImage = `https://auburnrvresort.com${heroMainAsset.url}`;


const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LodgingBusiness", "Campground"],
      name: resort.name,
      description,
      telephone: resort.phone,
      email: resort.email,
      url: "/reservations/",
      address: {
        "@type": "PostalAddress",
        streetAddress: resort.address.street,
        addressLocality: resort.address.city,
        addressRegion: resort.address.state,
        postalCode: resort.address.zip,
        addressCountry: "US",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: reservationFaqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export const Route = createFileRoute("/reservations")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ogImage },
      { property: "og:image:width", content: "1322" },
      { property: "og:image:height", content: "936" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: ogImage },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/reservations/") }, heroPreloadLink],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(schema) }],
  }),
  component: ReservationsPage,
});

function ReservationsPage() {
  return (
    <BookingProvider>
      <Navbar />
      <main>
        <ReservationHero />
        <ReservationProcess />
        <AvailabilityRequestForm />
        <ReservationFAQ />
        <ReservationSupport />
      </main>
      <Footer />
      <MobileBookingBar />
    </BookingProvider>
  );
}
